export class Editorcontrolitem {

  Id: number
  ControlClientId: string
  Type: string
  ControlType: string
  Property: string
  Version: string
  Children: Editorcontrolitem[]
  ChildrenII: Editorcontrolitem[]
  SettingsJson: string
  Settings: any = null;

  constructor(id: number, controlClientId: string, type: string, controlType: string, property: string, version: string, children: Editorcontrolitem[], settingsJson: string) {
    this.Id = id;
    this.ControlClientId = controlClientId;
    this.Type = type;
    this.ControlType = controlType;
    this.Property = property;
    this.Version = version;
    this.Children = children;
    this.SettingsJson = settingsJson;

    try {
      this.Settings = JSON.parse(settingsJson);
    }
    catch (e) {
      console.log("Error parsing JSON", settingsJson);
    }
  }

  public static mapItem(item: any): Editorcontrolitem {

    var controlsArray: Editorcontrolitem[] = [];
    if (item.Children && item.Children.length > 0) {

      item.Children.forEach(c => {
        let mc = Editorcontrolitem.mapItem(c);
        controlsArray.push(mc);
      });
    }
    let ci = new Editorcontrolitem(item.Id, item.Number, item.Type, item.ControlType, item.Property, item.Version, controlsArray, item.SettingsJson);
    return ci;
  }
}



